export let DATASET = 'UnknownDataset';

export const  globalSetDataset = (name) => {
    DATASET = name;
  };

// export const modeExecution = 'pctest';
export const modeExecution = 'server';
console.log("[GLOBAL] modeExecution = ", modeExecution)

export let SITE_WEB = "";

if(modeExecution === 'server') {
  SITE_WEB = 'https://www.accadil.fr'
}
if(modeExecution === 'pctest') {
  SITE_WEB = 'http://localhost:3001'
}

console.log("[GLOBAL] SITE_WEB = ", SITE_WEB)
